import CIMSTable from 'components/CIMSTable'
import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { useRouteMatches } from 'hooks/useRouteMatches'
import { useWorkflowFieldsQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useColumns } from './hooks/useColumns'
import { useEdit } from './hooks/useEdit'
import { useExpandOptions } from './hooks/useExpandOptions'

/**
 * Displays active workflow fields and their editable approval settings.
 */
const FieldsTable: React.VFC = () => {
  const { param } = useRouteMatches()
  const workflowId = param('workflowId')
  const { data, loading, refetch } = useWorkflowFieldsQuery({
    ...DefaultQueryHookOptions,
    skip: !workflowId,
    variables: workflowId ? { workflowId } : undefined,
  })

  return (
    <CIMSTable
      actions={{
        row: {
          edit: useEdit(refetch),
        },
        header: { onReload: refetch, deepLinkKey: 'id' },
      }}
      columns={useColumns()}
      expand={useExpandOptions()}
      loading={loading}
      records={data?.listFields.records ?? []}
      rowKey="id"
    />
  )
}

/**
 * Provides project-user metadata to the workflow Fields table.
 */
const Fields: React.VFC = () => (
  <UserSelectProvider>
    <FieldsTable />
  </UserSelectProvider>
)

export default Fields
